<template>
  <div class="source-content">
    <div class="filter-bar flex items-center">
      <div class="tb-form-group mb-0 min-w-0 flex-1">
        <div class="searchFilter__inputWrapper relative flex-1">
          <span class="fas fa-search searchFilter__icon absolute left-3 top-1/2 h-auto w-auto -translate-y-1/2 leading-none text-[15px]"></span>

          <input
            v-model="keywordSearch"
            type="text"
            class="tb-input tb-input--search searchFilter__input w-full pl-[30px] pr-[20px]"
            placeholder="Search collections"
            spellcheck="true"
            data-entity="producer-assets-searchShoppableCollections"
            data-test="producer-assets-collectionsSearch"
          />

          <button
            v-show="keywordSearch"
            class="searchFilter__clearSearch absolute right-3 top-1/2 -translate-y-1/2 rounded-full border-0 bg-transparent p-0 leading-none shadow-none appearance-none cursor-pointer"
            data-entity="producer-assets-clearShoppableCollectionSearch"
            data-test="producer-assets-clearCollectionsSearch"
            @click="resetCollectionSearch"
          >
            <span class="sr-only">Clear search term</span>
            <span class="fa fa-times"></span>
          </button>
        </div>
      </div>
    </div>

    <!-- No boards after searching -->
    <div v-if="!isLoadingCollections && !collections.length && keywordSearch" class="py-8 text-center">
      <h3 class="mb-4 text-[14px] font-semibold">
        No Collections found
      </h3>

      <button
        class="tb-btn tb-btn-contained medium-em px-3"
        data-entity="producer-assets-resetShoppableCollectionSearch"
        data-test="producer-assets-resetCollectionsSearch"
        @click="resetCollectionSearch"
      >
        Reset Search
      </button>
    </div>

    <!-- Collections -->
    <div
      ref="sourceList"
      class="source-list"
      data-test="producer-assets-curatedContent-list"
    >
      <button
        class="source-item cursor-pointer"
        data-test="producer-collection-allProducts"
        @click="setSelectedCollection(-1)"
      >
        <div class="source-item-wrapper">
          <div class="source-title">
            <span class="fas fa-bookmark mr-2"></span>
            All Saved Products
          </div>
        </div>
      </button>
      <button
        v-for="collection in collections"
        :key="collection.id"
        class="source-item cursor-pointer"
        :data-test="`producer-collection-:${collection.id}`"
        @click="setSelectedCollection(collection.id)"
      >
        <div class="source-item-wrapper">
          <span class="source-title">{{ collection.name }}</span>
        </div>
      </button>

      <div ref="loadTrigger" class="load-trigger flex min-h-16 w-full items-center justify-center">
        <div v-if="isLoadingCollections" class="loading loading--inline m-0" data-test="producer-assets-curatedContent-loading">
          <i class="fas fa-spinner fa-spin"></i>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState, mapGetters, mapActions } from 'vuex';
import { debounce } from 'lodash-es';

import tabMixins from '@/js/mixins/tab-mixins';

export default {
  name: 'CollectionList',
  mixins: [tabMixins],
  data() {
    return {
      intersectionObserver: null,
    };
  },
  computed: {
    ...mapState('shoppable', [
      'collections',
      'collectionTotal',
      'isLoadingCollections',
      'collectionSearch',
    ]),
    ...mapGetters('shoppable', [
      'hasMoreCollections',
    ]),

    keywordSearch: {
      get() {
        return this.collectionSearch;
      },
      set: debounce(function(value) {
        this.searchCollections(value);
      }, 500),
    },
  },
  watch: {
    isLoadingCollections(newVal) {
      if (!newVal && this.$refs.sourceList) {
        this.$nextTick(() => {
          if (this.$refs.sourceList.scrollHeight <= this.$refs.sourceList.offsetHeight) {
            // re-trigger observer
            this.intersectionObserver.unobserve(this.$refs.loadTrigger);
            this.intersectionObserver.observe(this.$refs.loadTrigger);
          }
        });
      }
    },
  },

  mounted() {
    this.intersectionObserver = new IntersectionObserver((entries) => {
      if (entries[0].isIntersecting) {
        this.loadMore();
      }
    }, {
      root: this.$refs.sourceList,
      threshold: 0,
    });

    this.intersectionObserver.observe(this.$refs.loadTrigger);
  },

  beforeUnmount() {
    if (this.intersectionObserver) {
      this.intersectionObserver.disconnect();
    }
  },
  methods: {
    ...mapActions('shoppable', [
      'incrementCollectionPage',
      'searchCollections',
      'resetCollectionSearch',
      'setSelectedCollection',
    ]),

    async loadMore() {
      if (!this.isLoadingCollections && this.hasMoreCollections) {
        await this.incrementCollectionPage();
      }
    },
  },
};
</script>
